export class SortMenuController {
    public static $inject: string[] = [
        "$scope"
    ];

    public context: string; // Binded
    public onSort; // Binded
    public sortParams; // Binded
    public sortTypes; // Binded - Optional

    private defaultSortParams;

    constructor(
        private $scope
    ) {}

    public $onInit() {
        this.defaultSortParams = angular.copy(this.sortParams);

        // Watch sortParams
        this.$scope.$watch(
        () => (this.sortParams),
        (current, previous) => {
            if (current !== previous) {
                this._sort();
            }
        },
        true);
    }

    public $onChanges(changes) {
        if (changes.sortParams) {
            this.sortParams = angular.copy(changes.sortParams.currentValue);
        }
    }

    public getPartial() {
        return `${ this.context }.sort-menu`;
    }

    public reset() {
        this.sortParams = this.defaultSortParams;
        this._sort();
    }

    public sort() {
        this._sort();
    }

    private _sort() {
        this.onSort({
            $event: {
                sortParams: this.sortParams
            }
        });
    }
}
